import React from 'react';
import { createFdIcon } from './createFdIcon';

// Branded feature icons — the MMA/collecting concepts carry the brand. Built to
// the Bare Knuckle construction spec (24×24, currentColor, 2px, butt/miter,
// angular). Curves used only where the subject physically curves (rings, lenses).

// Binder spine, three rings — the product metaphor.
export const BinderIcon = createFdIcon(
  <>
    <rect x="4" y="3" width="16" height="18" />
    <line x1="8" y1="3" x2="8" y2="21" />
    <circle cx="8" cy="8" r="1.5" />
    <circle cx="8" cy="12" r="1.5" />
    <circle cx="8" cy="16" r="1.5" />
  </>,
  'BinderIcon'
);

// Single trading card: rect + thin inner frame.
export const CardIcon = createFdIcon(
  <>
    <rect x="6" y="3" width="12" height="18" />
    <rect x="8" y="5" width="8" height="14" />
  </>,
  'CardIcon'
);

// Three fanned cards.
export const CardStackIcon = createFdIcon(
  <>
    <rect x="4" y="8" width="8" height="12" />
    <rect x="8" y="6" width="8" height="12" />
    <rect x="12" y="4" width="8" height="12" />
  </>,
  'CardStackIcon'
);

// Card outline with a plus in the corner.
export const CardAddIcon = createFdIcon(
  <>
    <rect x="4" y="3" width="11" height="16" />
    <line x1="17" y1="14" x2="17" y2="20" />
    <line x1="14" y1="17" x2="20" y2="17" />
  </>,
  'CardAddIcon'
);

// 2×2 card grid, one tile checked.
export const ChecklistIcon = createFdIcon(
  <>
    <rect x="3" y="3" width="8" height="8" />
    <rect x="13" y="3" width="8" height="8" />
    <rect x="3" y="13" width="8" height="8" />
    <rect x="13" y="13" width="8" height="8" />
    <polyline points="4.5,16.8 6.5,18.8 9.5,15" />
  </>,
  'ChecklistIcon'
);

// Three offset layered card outlines — parallels as depth (not a rainbow).
export const ParallelsIcon = createFdIcon(
  <>
    <rect x="3" y="5" width="8" height="14" />
    <rect x="8" y="5" width="8" height="14" />
    <rect x="13" y="5" width="8" height="14" />
  </>,
  'ParallelsIcon'
);

// Reticle over a card corner — the card in your sights.
export const ChaseIcon = createFdIcon(
  <>
    <rect x="3" y="7" width="11" height="14" />
    <circle cx="16" cy="8" r="4" />
    <line x1="16" y1="2" x2="16" y2="5" />
    <line x1="16" y1="11" x2="16" y2="14" />
    <line x1="10" y1="8" x2="13" y2="8" />
    <line x1="19" y1="8" x2="22" y2="8" />
  </>,
  'ChaseIcon'
);

// Progress ring with a hard gap and a tick.
export const CompletionIcon = createFdIcon(
  <>
    <path d="M12 3.5 A8.5 8.5 0 1 1 6.5 5.6" />
    <line x1="12" y1="1" x2="12" y2="6" />
  </>,
  'CompletionIcon'
);

// Championship belt: center plate, side plates, strap.
export const BeltIcon = createFdIcon(
  <>
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="2" y1="14" x2="22" y2="14" />
    <rect x="9" y="6" width="6" height="12" />
    <rect x="4" y="9" width="4" height="6" />
    <rect x="16" y="9" width="4" height="6" />
  </>,
  'BeltIcon'
);

// Raised fist with hand-wrap lines.
export const FistIcon = createFdIcon(
  <>
    <path d="M6 15 V10 H8 V7 H11 V6 H14 V8 H17 V10 H18 V15 Z" />
    <line x1="18" y1="12" x2="20" y2="12" />
    <line x1="7" y1="18" x2="17" y2="18" />
    <line x1="6" y1="15" x2="6" y2="18" />
    <line x1="18" y1="15" x2="18" y2="18" />
  </>,
  'FistIcon'
);

// Pen nib + a signature stroke — autograph cards.
export const SignatureIcon = createFdIcon(
  <>
    <polyline points="3,20 7,13 9,16 13,9" />
    <path d="M13 9 L17 4 L20 7 L16 12 Z" />
  </>,
  'SignatureIcon'
);

// Card with a centered square swatch window — memorabilia.
export const RelicIcon = createFdIcon(
  <>
    <rect x="6" y="3" width="12" height="18" />
    <rect x="9" y="9" width="6" height="6" />
  </>,
  'RelicIcon'
);

// Shield with a star — rookie cards.
export const RookieIcon = createFdIcon(
  <>
    <path d="M12 3 L20 6 V13 L12 21 L4 13 V6 Z" />
    <polyline points="12,8 13.4,11 16.5,11.2 14,13.3 14.9,16.3 12,14.6 9.1,16.3 10,13.3 7.5,11.2 10.6,11" />
  </>,
  'RookieIcon'
);

// Sharp-cornered camera — card photo capture.
export const CameraIcon = createFdIcon(
  <>
    <rect x="3" y="7" width="18" height="12" />
    <polyline points="8,7 9,4 15,4 16,7" />
    <circle cx="12" cy="13" r="3.2" />
  </>,
  'CameraIcon'
);

// Card with an up arrow — upload.
export const UploadIcon = createFdIcon(
  <>
    <rect x="5" y="3" width="14" height="18" />
    <line x1="12" y1="17" x2="12" y2="9" />
    <polyline points="8,13 12,9 16,13" />
  </>,
  'UploadIcon'
);

// Tally bars, hard tops.
export const StatsIcon = createFdIcon(
  <>
    <line x1="3" y1="20" x2="21" y2="20" />
    <line x1="6" y1="20" x2="6" y2="12" />
    <line x1="11" y1="20" x2="11" y2="6" />
    <line x1="16" y1="20" x2="16" y2="14" />
    <line x1="20" y1="20" x2="20" y2="9" />
  </>,
  'StatsIcon'
);

// Calendar with a corner cut.
export const CalendarIcon = createFdIcon(
  <>
    <path d="M4 6 H17 L20 9 V20 H4 Z" />
    <line x1="4" y1="10" x2="20" y2="10" />
    <line x1="8" y1="4" x2="8" y2="7" />
    <line x1="15" y1="4" x2="15" y2="7" />
  </>,
  'CalendarIcon'
);
